export const filterEmployeesForEmployeeSchedule = (userEmployees, currentUserId, locationId) =>
  userEmployees.filter(({ id, inactive, locations, terms }) => {
    const isNotCurrentUser = id !== currentUserId;
    const isActive = !inactive;
    const isWorkingInLocation = locations.some(location => location.id === locationId);
    const hasTerms = Boolean(terms.length);
    return isNotCurrentUser && isActive && isWorkingInLocation && hasTerms;
  });
